module.exports = __webpack_public_path__ + "static/resume-ecfd34bfd9129c4a82fc960502b25498.pdf";